export const Endpoint = () => `/api/v3/celery/botnameslist`;
export const QueryKey = () => ['v3', 'admin', 'celery', 'botNames'] as const;
export type Payload = never;
export type Response = string[];
